<template>
  <b-card class="m-0 p-0" no-body>
    <b-card-body class="m-0 p-0">
      <b-alert show>
        <b-button v-b-toggle.collapse-1 variant="primary"
          >Show Disclaimer</b-button
        >
        <b-collapse id="collapse-1" is-nav>
          <p class="pt-2">
            This report reflect the revenue value and total stock consumed
            during the specified period of time on a category and date based
            breakdown. These daily totals may differ from the total of revenue
            collected in such period of time because this report doesn't caught
            order's total discounts like promo codes/vouchers applied to the
            order's total value. This report does includes discounts related to
            per product discounts or loyalty product rewards (example: free
            coffee after X number of loyalty stamps or a promo code/voucher for
            a specific free/discounted product).
          </p>
        </b-collapse>
      </b-alert>
      <table class="table b-table table-hover table-borderless table-sm">
        <tbody>
          <tr>
            <th class="table-primary b-table-sticky-column position-relative">
              Categories
            </th>
            <th
              v-for="day of dates"
              :key="moment(day).toISOString()"
              class="table-primary b-table-sticky-column position-relative"
            >
              {{ moment(day).format("DD/MM/YYYY") }}
            </th>
            <th class="table-primary b-table-sticky-column position-relative">
              Total
            </th>
          </tr>
          <tr v-for="category of categoryNames" :key="category">
            <td class="table-b-table-default b-table-sticky-column">
              {{ category }}
            </td>
            <td v-for="day of dates" :key="moment(day).toISOString()">
              <categories-cell :data="getCellData(day, category)" />
            </td>
            <td>
              <categories-cell :data="getTotalCellData(category)" />
            </td>
          </tr>
          <tr>
            <td class="table-success font-weight-bold">Report Summary</td>
            <td
              class="table-success font-weight-bold"
              :colspan="dates.length + 1"
            >
              <categories-cell :data="getTotalReportCellData()" />
            </td>
          </tr>
        </tbody>
      </table>
    </b-card-body>
  </b-card>
</template>

<script>
import * as moment from "moment";
import CategoriesCell from "@/components/reports/categories-cell";
import { getProductTotalCost } from "@/utils/orders/formulas";

export default {
  name: "categories",
  components: { CategoriesCell },
  props: ["report"],
  data: () => ({}),
  computed: {
    categoryNames() {
      let categoryNames = [];
      for (let item of this.report.data) {
        categoryNames = [
          ...categoryNames,
          ...item.lineItems.map(
            (li) =>
              li.product && li.product.category && li.product.category.name
          ),
        ];
      }
      return Array.from(new Set(categoryNames));
    },
    dates() {
      let dates = [];

      let currDate = moment(this.report.startDate, "DD-MM-YYYY").startOf("day");
      let lastDate = moment(this.report.endDate, "DD-MM-YYYY").startOf("day");

      while (currDate.add(1, "days").diff(lastDate) < 1) {
        dates.push(currDate.clone().toDate());
      }

      return dates;
    },
  },
  methods: {
    moment,
    getEmail(data) {
      if (data.item.owner) {
        return (
          data.item.owner &&
          data.item.owner.profile &&
          data.item.owner.profile.email
        );
      } else {
        return (
          data.item.guestOwner &&
          data.item.guestOwner.profile &&
          data.item.guestOwner.profile.email
        );
      }
    },
    getCellData(date, category) {
      let filteredOrders = this.report.data.filter((o) => {
        return (
          moment(o.createdAt).isSame(moment(date), "day") &&
          o.lineItems.filter((li) => li.product.category.name === category)
            .length > 0
        );
      });
      let filteredLineItems = filteredOrders
        .map((o) => o.lineItems)
        .flat(1)
        .filter((li) => li.product.category.name === category);
      let stock = filteredLineItems.reduce((sum, next) => {
        return sum + next.quantity;
      }, 0);
      let total = filteredLineItems.reduce((sum, next) => {
        return sum + getProductTotalCost(next);
      }, 0);

      return { items: stock, total };
    },
    getTotalCellData(category) {
      let filteredOrders = this.report.data.filter((o) => {
        return (
          o.lineItems.filter((li) => li.product.category.name === category)
            .length > 0
        );
      });
      let filteredLineItems = filteredOrders
        .map((o) => o.lineItems)
        .flat(1)
        .filter((li) => li.product.category.name === category);
      let stock = filteredLineItems.reduce((sum, next) => {
        return sum + next.quantity;
      }, 0);
      let total = filteredLineItems.reduce((sum, next) => {
        return sum + getProductTotalCost(next);
      }, 0);

      return { items: stock, total };
    },
    getTotalReportCellData() {
      let filteredLineItems = this.report.data.map((o) => o.lineItems).flat(1);
      let stock = filteredLineItems.reduce((sum, next) => {
        return sum + next.quantity;
      }, 0);
      let total = filteredLineItems.reduce((sum, next) => {
        return sum + getProductTotalCost(next);
      }, 0);

      return { items: stock, total };
    },
    getCSVData() {
      let csvContent =
        "," +
        this.dates.map((d) => moment(d).format("DD/MM/YYYY")).join(",") +
        ", Total\r\n";
      for (let category of this.categoryNames) {
        csvContent += `"${category}"`;
        for (let day of this.dates) {
          const cellData = this.getCellData(day, category);
          csvContent += `, Items: ${cellData.items} - Total: $${(
            cellData.total / 100
          ).toFixed(2)}`;
        }
        const totalCellData = this.getTotalCellData(category);
        csvContent += `, Items: ${totalCellData.items} - Total: $${(
          totalCellData.total / 100
        ).toFixed(2)}`;

        csvContent += "\r\n";
      }
      csvContent += "Report Summary";
      const totalRowCellData = this.getTotalReportCellData();
      csvContent += `, Items: ${totalRowCellData.items} - Total: $${(
        totalRowCellData.total / 100
      ).toFixed(2)}`;
      return csvContent;
    },
  },
};
</script>

<style scoped></style>
